const steps = {
  INFORMATION: 'YOURINFORMATION',
  ADDRESS: 'YOURADDRESS',
  INDUSTRY: 'SELECTINDUSTRY',
}

export default steps;